var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilidade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 62,
    viewBox: "0 0 38 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xC3\x8Dcone Visibilidade"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.4304 1H4.56962C2.59817 1 1 2.45288 1 4.24511V57.7549C1 59.5471 2.59817 61 4.56962 61H33.4304C35.4018 61 37 59.5471 37 57.7549V4.24511C37 2.45288 35.4018 1 33.4304 1Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.3164 33.6899H30.587",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.3164 38.3599H30.587",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.3164 42.845H30.587",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.3164 47.4456H30.587",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.5195 57.0859H20.2303",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.155 33.6899H8V38.3599H17.155V33.6899Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.155 42.7756H8V47.4456H17.155V42.7756Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.7684 18.2004H26.9805C29.0612 18.2004 30.7488 19.8881 30.7488 21.9688V26.8468H8V21.9688C8 19.8881 9.68767 18.2004 11.7684 18.2004V18.2004Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M12.5312 9.39209H26.2406C27.3272 9.39209 28.2057 10.2706 28.2057 11.3572V18.0385H10.543V11.3572C10.543 10.2706 11.4215 9.39209 12.5081 9.39209H12.5312Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16.8769 14.7324H21.8705C22.9571 14.7324 23.8356 15.6109 23.8356 16.6975V18.0384H14.8887V16.6975C14.8887 15.6109 15.7672 14.7324 16.8538 14.7324H16.8769Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M8 23.4482H30.7488",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilidade);
export default __webpack_public_path__ + "static/media/Visibilidade.05314ec019b6d297c173163b282d735e.svg";
export { ForwardRef as ReactComponent };